module.exports = __webpack_public_path__ + "fonts/Muli-SemiBold.14fe852c.woff2";